export const ElementsStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
      csradio: {
        size: 'lg',
        color: 'BLACK',
        borderColor: 'GRAY',
        marginBottom: 'auto',
        marginTop: '5px',
      },
      radio: {
        size: 'lg',
        color: 'BLACK',
        borderColor: 'GRAY',
      }
      ,
      radioCard: {
        display: 'grid',
        gridTemplateAreas: 'box',
        border: '1px',
        borderColor: 'GRAY',
        // cursor: 'pointer',
        _hover: {
          borderColor: 'ORANGE',
        },
      },
      templateImage: {
        gridArea: 'box',
      },
      focusOverlay: {
        gridArea: 'box',
        backgroundColor: '#FFF3EC',
        opacity: '85%',
      },
      expertise: {
        checkbox: {
          size: 'lg',
          iconColor: 'WHITE',
          paddingTop: '32px',
          color: 'BLACK',
          borderColor: 'GRAY',
          display: 'flex',
        },
      },
      templateWrapper: {
        marginTop: ['16px', null, '24px'],
        border: '1px',
        borderColor: 'GRAY',
        borderRadius: '4px',
        padding: '24px',
      },
    },
  },
};
